import script from "./ToggleAccordion.vue?vue&type=script&lang=js"
export * from "./ToggleAccordion.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__